var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('widget',{attrs:{"widget":_vm.widget,"loading":_vm.isFetchingWidgets}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }